import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from '../LabelText';

const Gender = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);

	const userData = useSelector(state => state.userData);

	useEffect(() => { // to be updated after render
		i18n.changeLanguage(props.lang);
	}, []);

	useEffect(() => { // to be updated after render
		if (fv && form_component.required) {
			fv.addField('gender', {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			});
		}
	}, [fv]);

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				lang={props.lang}
				form_component={form_component}
			/>
		 	<div className={`label_box ${form_component.option_display === '1R1D' ? 'label-full' : 'label-50'}`}>
		 		{(() => {
		 			const components = [];
		 			
		 			form_component.options.map((option, index) => {
		 				components.push(
		 					<React.Fragment key={`option-${index}`}>
		 					<input
		 						className="form-check-input"
		 						type="radio"
		 						name="gender"
		 						id={`gender-${option.value}`}
		 						value={option.value}
		 						checked={userData && userData.gender === option.value}
		 					/>
		 					<label
		 						className="form-check-label"
		 						htmlFor={`${form_component.fieldname}-${option.value}`}
		 					>
								<div className="d-flex gap-3 opt">
									<div className="x-radio"></div>
									<div className="ans">
				 					    <p className="mb-0">{option.label}</p>
				 					    <div className="pic w-100">
				 					    
				 					    </div>
			 						</div>
			 					</div>
			 				</label>
		 					</React.Fragment>
		 				);
		 			});

		 			return components;
		 		})()}
		  </div>
		</div>
	);
}

export default Gender;